<div class="row">
  <div class="col-md-6">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Resource {{Title}}</h4>
        <div class="form-group">
          <label for="ResourceName">Resource Name *</label>
          <div class="input-group">
            <input type="text" class="required form-control" required id="ResourceName" [(ngModel)]="Doc.ResourceName"
              #ResourceName="ngModel" aria-label="Resource Name" placeholder="" />
          </div>
          <div [hidden]="ResourceName.valid || ResourceName.pristine" class="alert alert-danger">
            Resource Name is required
          </div>
        </div>
        <div class="form-group">
          <label for="Enabled">Enabled</label>
          <ng-select [searchable]="false" [items]="Doc.ddlEnabled" id="Enabled" bindValue="value" bindLabel="text"
            [clearable]="false" [(ngModel)]="Doc.SelectEnabled">
          </ng-select>
        </div>
        <div class="form-group">
          <label for="Action">Action</label>
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th style="width: 100%;">Name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let Doc of Doc.ActionNameList; let i = index">
                <td>
                  <button class="btn btn-outline-secondary" type="button" (click)="DeleteAction(i)">Del</button>
                </td>
                <td>
                  <input [(ngModel)]="Doc.ActionName" class="form-control" type="text" name="{{Doc.ActionName}}" />
                </td>
              </tr>
              <tr>
                <td>
                  <button class="btn btn-success" type="button" (click)="AddAction()">Add</button>
                </td>
                <td>
                  <input class="form-control" type="text" id="ActionName" [(ngModel)]="newAction.ActionName"
                    name="ActionName" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>(*) Mandatory</p>
      </div>
      <div class="border-top">
        <div class="card-body">
          <button (click)="Cancel()" class="btn btn-outline-secondary" role="button">Cancel</button>
          <button (click)="Submit()" class="btn btn-success ml-1" role="button" [disabled]="isValid()">Submit</button>
        </div>
      </div>
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Container fluid  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- footer -->
  <!-- ============================================================== -->
  <footer class="footer text-center"></footer>
  <!-- ============================================================== -->
  <!-- End footer -->
  <!-- ============================================================== -->
</div>
